export default __webpack_public_path__ + "static/media/popout.d92e914f.svg";